import React, { useState } from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  CustomerSearchCriteria,
  PageListBean,
  RestCustomerListRequest,
  RestEntityUnLockRequest,
  RestPageListBean,
  RestReadRequest,
  RestSalesOrderListRequest,
  SalesOrderBean,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  DatePickerComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { SalesOrderLookupHandler } from "../lookup/SalesOrderLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { PopupCustomerModule, PopupSalesModule } from "./ModuleUtil.js";
import { ModuleUtils } from "./ModuleUtils.js";
class ApproveSalesOrder extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Mass Appprove Sales Order",
      salesOrderList: new Array(),
      pageList: new PageListBean(),
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      error_list: [],
      pageList: new PageListBean(),
      dataListFound: false,
      criteria: new SalesOrderSearchCriteria(),
      companyCode: "",
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      alertMsg: "",
      isShowCustomerModule: false,
      isShowSalesModule: false,
      moduleForPopup: [],
      showAutoCompleteCustomerList: true,
      customerPageListForAutoCompleteList: new Array(),
      salesOrderListForAutoCompleteList: new Array(),
      showAutoCompleteSalesOrderList: true,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      salesOrderData: new SalesOrderBean(),
      order: "asc",
      customerLookupHandler: null,
      salesOrderLookupHandler: null,
      isDisableFields: false,
      isShowCustomerLookup: true,
      isShowSalesOrderLookup: true,
      isCollapsible_open: true,
      order: "asc",
      sortField: "",
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    ModuleUtils.getSalesOrderStatusList();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let salesOrderLookupHandler = new SalesOrderLookupHandler(
      this.companyCode,
      "SalesOrderNumber"
    );
    this.setState({ salesOrderLookupHandler: salesOrderLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  approveSalesOrder = (e, soBean) => {
    if (e.detail == 1) {
      let salesOrderData = soBean;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Approving...",
        salesOrderData: salesOrderData,
      });
      this.lockSalesOrder(salesOrderData.code);
    }
  };
  approveSalesOrderResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null && response.data.salesOrder != null) {
      let salesOrderData = response.data.salesOrder;
      this.unlockSalesOrder(salesOrderData.code);
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  lockSalesOrder = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    SalesOrderService.lockSalesOrder(
      request,
      this.lockSalesOrderResponse,
      this.errorCallBack
    );
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  lockSalesOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data.isSuccess) {
      let soBean = this.state.salesOrderData;
      if (SecurityAccessManager.MassApproveSalesOrders_IsAccessible()) {
        SalesOrderService.approveSalesOrder(
          soBean,
          this.approveSalesOrderResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(1);
      }
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  handleApproveResponse = (response) => {
    let isSuccess = false;
    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.infos != null) {
      response.infos.map(
        (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
      );
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      isSuccess = true;
    }
    if (response.errors != null) {
      response.errors.map(
        (err) => (
          (errMsg = errMsg + "\n" + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      isSuccess = false;
    }
    return isSuccess;
  };
  unlockSalesOrder = (code) => {
    let data = new RestEntityUnLockRequest();
    data.companyCode = this.companyCode;
    data.entityCode = code;
    SalesOrderService.unLockSalesOrder(
      data,
      this.unlockSalesOrderResponse,
      this.errorCallBack
    );
  };
  unlockSalesOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data.isSuccess) {
      this.loadPage(1);
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  execute = () => {
    this.loadPage(1);
    this.hideAlertCallBack();
  };
  clearCriteria = () => {
    let criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = "";
    criteria.customerName = "";
    criteria.salesOrderNumber = "";
    this.setState({ criteria: criteria });
  };
  reset = () => {
    let criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = "";
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      dataListFound: false,
      salesOrderList: new Array(),
      isDisableFields: false,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowCustomerLookup: true,
      isShowSalesOrderLookup: true,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  loadPage = (pageNumber) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing..",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.orderStatus = LogicConstants.SALES_ORDER_UNAPPROVE_STATUS;
    let pageInput = new PageListBean();
    pageInput.currentPage = pageNumber;
    let listrequest = new RestSalesOrderListRequest();
    listrequest.searchCriteria = criteria;
    listrequest.pageInput = pageInput;
    this.loadSalesOrderPageList(listrequest);
  };
  loadSalesOrderPageList = (listrequest) => {
    SalesOrderService.getSalesOrderPageList(
      listrequest,
      this.loadSalesOrderPageListPageResponse,
      this.errorCallBack
    );
  };
  loadSalesOrderPageListPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.salesOrderPageList != null) {
      let salesOrderList = new Array();
      if (!isEmptyArray(response.data.salesOrderPageList.salesOrders)) {
        salesOrderList = response.data.salesOrderPageList.salesOrders;
      }
      this.setState({
        dataListFound: true,
        isDisableFields: true,
        salesOrderList: salesOrderList,
        isShowClearCriteriaButton: false,
        isShowResetButton: true,
        isShowProgressBarPopup: false,
        progressLoadingText: " ",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error: " + error);
  };
  viewCustomerCode = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalexit}
            />
          ),
        });
      }
    }
  };
  viewSalesOrderCode = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalexit}
            />
          ),
        });
      }
    }
  };
  onPopupModalexit = () => {
    this.closeModalCallBack(false);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
      error_list: [],
    });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowSalesModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleforPopup: [],
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList == true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ critera: tempCriteria });
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let customer_pageList = new RestPageListBean();
    customer_pageList.pageSize = 100;
    let customer_requestInput = new RestCustomerListRequest();
    customer_requestInput.pageInput = customer_pageList;
    customer_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      customer_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  salesOrderOnChange = (e) => {
    let salesOrderNumber = e.target.value;
    this.state.showAutoCompleteSalesOrderList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
    if (isEmpty(salesOrderNumber)) {
      this.state.showAutoCompleteSalesOrderList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
      let criteria = this.state.criteria;
      criteria.salesOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteSalesOrderList: showAutoCompleteList,
        criteria: criteria,
        salesOrderListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "salesOrderNumber" &&
      showAutoCompleteList === true &&
      salesOrderNumber !== ""
    ) {
      this.readSalesOrderBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetSalesOrderDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.salesOrder != null) {
      let salesOrderData = response.data.salesOrder;
      if (!isEmpty(salesOrderData)) {
        criteria.salesOrderNumber = salesOrderData.code;
        this.setState({
          criteria: criteria,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  readandsetSalesOrderDetail = (salesOrderNumber) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = salesOrderNumber;
    input.isLoadChildren = true;
    SalesOrderService.readSalesOrder(
      input,
      this.readandsetSalesOrderDetailResponse,
      this.errorCallBack
    );
  };
  readSalesOrderBySearchString(searchString) {
    let searchCriteria = new SalesOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.salesOrderNumberStartsWith = searchString;
    searchCriteria.salesOrderNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestSalesOrderListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    SalesOrderService.getSalesOrderPageList(
      input,
      this.readBySalesOrderCodeResponse,
      this.errorCallBack
    );
  }
  readBySalesOrderCodeResponse = (response) => {
    let salesOrderNumberData = response.data.salesOrderPageList.salesOrders;
    let simpleAutoCompleteList = new Array();
    if (salesOrderNumberData.length > 0 && salesOrderNumberData != null) {
      salesOrderNumberData.map((salesOrderNumber) => {
        let simpleItemBean = {
          code: salesOrderNumber.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      salesOrderListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  salesOrderEnterKeyEventHandler = (e) => {
    let salesOrderNumber = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading ...",
    });
    this.readandsetSalesOrderDetail(salesOrderNumber);
    this.setState({
      salesOrderListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesOrderList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesOrderList: showAutoCompleteList });
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.salesOrderList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ salesOrderList: sorted });
    }
  };
  render() {
    let salesOrderList = this.state.salesOrderList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          hideAlertCallBack={this.hideAlertCallBack}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          clearCriteria={this.clearCriteria}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          reset={this.reset}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          salesOrderEnterKeyEventHandler={this.salesOrderEnterKeyEventHandler}
          displayAutoCompleteSalesOrderList={
            this.displayAutoCompleteSalesOrderList
          }
          salesOrderOnChange={this.salesOrderOnChange}
          showHideSecondHeader={this.showHideSecondHeader}
        />
        {this.state.dataListFound && (
          <>
            <Row>
              <FormLabel className="table_title">SalesOrder List</FormLabel>
            </Row>

            <div className="div_default">
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingchange(e, "customerCode")
                      }
                    >
                      Customer
                      {this.state.order === "desc" &&
                      this.state.sortField === "customerCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingchange(e, "customerName")
                      }
                    >
                      CustomerName
                      {this.state.order === "desc" &&
                      this.state.sortField === "customerName" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th onClick={(e) => this.handleSortingchange(e, "code")}>
                      salesOrder #
                      {this.state.order === "desc" &&
                      this.state.sortField === "code" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingchange(e, "orderStatus")
                      }
                    >
                      Status
                      {this.state.order === "desc" &&
                      this.state.sortField === "orderStatus" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingchange(e, "orderStartDate")
                      }
                    >
                      StartDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "orderStartDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingchange(e, "orderStopDate")
                      }
                    >
                      StopDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "orderStopDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {salesOrderList.map((data, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewCustomerCode(e, data.customerCode)
                          }
                        >
                          {data.customerCode}
                        </Button>
                      </td>
                      <td>{data.customerName}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.viewSalesOrderCode(e, data.code)}
                        >
                          {data.code}
                        </Button>
                      </td>
                      <td>
                        {ModuleUtils.getSalesOrderStatusCaption(
                          data.orderStatus
                        )}
                      </td>
                      <td>{data.orderStartDate}</td>
                      <td>{data.orderStopDate}</td>
                      <td>
                        <Button
                          id="fabric_Add_Button"
                          onClick={(e) => this.approveSalesOrder(e, data)}
                        >
                          ApproveSalesOrder
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {salesOrderList.length != 0 ? null : (
                <div className="no_Data">{"No Data"}</div>
              )}
            </div>
          </>
        )}
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowCustomerModule}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowSalesModule}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const onChange = (e) => props.onChange(e);
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  let criteria = props.criteria;
  let customerLookupHandler = props.customerLookupHandler;
  let salesOrderLookupHandler = props.salesOrderLookupHandler;
  let salesOrderRef = React.createRef();
  const customerCodeRef = props.customerCodeRef;
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const salesOrderOnChange = (e) => {
    props.salesOrderOnChange(e);
  };
  const salesOrderEnterKeyEventHandler = (e) => {
    props.salesOrderEnterKeyEventHandler(e);
  };
  const displayAutoCompleteSalesOrderList = () => {
    props.displayAutoCompleteSalesOrderList();
  };
  const showHideSecondHeader = (e) => {
    if (e.detail == 1) props.showHideSecondHeader();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={customerCodeOnChange}
            lookupRequired={props.isShowCustomerLookup}
            value={criteria.customerCode}
            showCriteriaDialog={true}
            lookupHandler={customerLookupHandler}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            displayAutoCompleteList={displayAutoCompleteList}
            enableAutoCompleteTextBox={true}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="customerName"
            onChange={onChange}
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>SalesOrder FromDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="orderStopDatefrom"
            value={criteria.orderStopDatefrom}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel>SalesOrder ToDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="orderStopDateto"
            value={criteria.orderStopDateto}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col>
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => showHideSecondHeader(e)}
          />
        </Col>
      </Row>
      {props.isCollapsible_open && (
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            <FormLabel>Sales Order Number</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              lookupRequired={props.isShowSalesOrderLookup}
              ref={salesOrderRef}
              name="salesOrderNumber"
              onChange={salesOrderOnChange}
              value={criteria.salesOrderNumber}
              lookupHandler={salesOrderLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={salesOrderEnterKeyEventHandler}
              autoCompleteListData={props.salesOrderListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteSalesOrderList}
              showAutoCompleteList={props.showAutoCompleteSalesOrderList}
              disabled={props.isDisableFields}
              isMandatory={true}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
function ApproveSalesOrderModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <ApproveSalesOrder {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default ApproveSalesOrderModule;
